<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
	<div class="flex flex-column align-items-center justify-content-center">
		<img [src]="getMenuTheme() === 'dim' ? './assets/images/logos/CAME-A_alpha_white_blue.png' : './assets/images/logos/CAME-A_alpha_white.png'" alt="CAME Logo" class="mb-6 w-16rem flex-shrink-0">
		<div class="card surface-800 border-round flex align-items-center justify-content-center p-0">
			<div class="w-full p-8 flex flex-column align-items-center">
				<span class="text-blue-500 font-bold text-8xl">404</span>
				<h1 class="font-bold text-5xl lg:text-8xl mb-2 text-center">{{ 'PAGE_NOT_FOUND' | translate }}</h1>
				<button pButton pRipple
					label="{{ 'BACK_TO_LOGIN' | translate }}" routerLink="/login"
					class="p-button-secondary text-2xl my-5">
				</button>
				<i class="mt-3 pi cm-alert" style="font-size: 14rem"></i>
			</div>
		</div>
	</div>
</div>